export const filterDependsAnswers = (dependsOnAnswersArray, answersArray) => {
  let answersArrayCopy = [...answersArray];
  const secondArrayMap = new Map();
  answersArrayCopy.forEach((obj, index) => {
    secondArrayMap.set(obj.questionId, { ...obj, index });
  });

  const secondArrayAnsId = answersArrayCopy
    .map((obj) => obj.answers.map((el) => el.answerId))
    .flat();

  dependsOnAnswersArray.forEach((firstObj) => {
    const secondObj = secondArrayMap.get(firstObj.questionId);
    if (secondObj) {
      const requiredIds = Array.isArray(firstObj.dependsOnAnswers)
        ? firstObj.dependsOnAnswers
        : [firstObj.dependsOnAnswers];

      const allAnswersPresent = requiredIds.every((id) => secondArrayAnsId.includes(id));

      if (!allAnswersPresent) {
        answersArrayCopy.splice(secondObj.index, 1);
        // Re-mappa gli indici dopo la rimozione
        for (let i = secondObj.index; i < answersArrayCopy.length; i++) {
          secondArrayMap.set(answersArrayCopy[i].questionId, {
            ...answersArrayCopy[i],
            index: i,
          });
        }
      }
    }
  });

  return answersArrayCopy;
};

export const idDependsOnAnswerFullfilled = (questions, setDependsOnAnswersState) => {
  const answers = questions
    .filter((el) => el.dependsOnAnswers && el.dependsOnAnswers.length > 0)
    .map((question) => ({
      questionId: question.id,
      dependsOnAnswers: question.dependsOnAnswers,
    }));
  setDependsOnAnswersState(answers);
};

export const updateAnswersData = (prevAnswers, e, questionId, answerId, type, dependsOnAnswers) => {
  const { value, checked } = e.target;

  let updatedAnswers = JSON.parse(JSON.stringify(prevAnswers));

  const questionIndex = updatedAnswers.findIndex((q) => q.questionId === questionId);

  if (questionIndex === -1) {
    updatedAnswers.push({
      questionId,
      answers: [
        {
          answerId,
          value: type === 'checkbox' ? (checked ? 'on' : null) : type === 'radio' ? 'on' : value,
        },
      ],
    });
  } else {
    const answers = updatedAnswers[questionIndex].answers;
    const answerIndex = answers.findIndex((a) => a.answerId === answerId);

    if (type === 'checkbox') {
      if (answerIndex === -1 && checked) {
        answers.push({ answerId, value: 'on' });
      } else if (answerIndex !== -1) {
        answers[answerIndex].value = checked ? 'on' : null;
      }
    } else if (type === 'radio') {
      answers.forEach((a) => {
        a.value = a.answerId === answerId ? 'on' : null;
      });
      if (answerIndex === -1) {
        answers.push({ answerId, value: 'on' });
      }
    } else {
      const newValue = type === 'input-num' ? parseFloat(value) : value;
      if (answerIndex === -1) {
        answers.push({ answerId, value: newValue });
      } else {
        answers[answerIndex].value = newValue;
      }
    }

    updatedAnswers[questionIndex].answers = answers.filter(
      (a) => a.value !== null && a.value !== ''
    );

    if (updatedAnswers[questionIndex].answers.length === 0) {
      updatedAnswers.splice(questionIndex, 1);
    }
  }

  return filterDependsAnswers(dependsOnAnswers, updatedAnswers);
};
